export default __webpack_public_path__ + "static/media/door.9e6595ac.png";